/* eslint-disable jsx-a11y/anchor-has-content */
import {
  Box,
  Container,
  Flex,
  Heading,
  HStack,
  Icon,
  Square,
  Stack,
  Text,
  VStack,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { RiDownload2Line } from "react-icons/ri";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import Layout from "../../../components/student/Layout/layout";
import VideoPreview from "../../../containers/student/video/videoPreview";
import axiosInstance from "../../../helpers/api";
import { openSolveHomeworkModel } from "../../../modules/admin-modules/models/Actions";

const VideosPreview = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { id } = useParams();
  const [loading, setLoading] = useState(false);

  const [otp, setOtp] = useState("");
  const [playBack, setPlayBack] = useState("");
  const baseUrl = "https://enoughphysics.com/enoughapi";
  const videoDetails = useSelector((state) => state.chapterVideos.videoDetails);
  const getVideoData = async (id) => {
    //console.log(id, "get");
    const res = await axiosInstance.get(`/student/videos/otp/${id}`);
    setOtp(res?.data?.otp);
    setPlayBack(res?.data?.playbackInfo);
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 2000);
  };

  useEffect(() => {
    if (id) {
      getVideoData(id);
    }
  }, [id]);
  return (
    <Layout color="main_1" bg="white" isLoading={false}>
      <Container maxW="container.2xl" h="100%" my="100px" mb="165px" w="100%">
        <Stack
          flexDirection="column"
          w="100%"
          justifyContent="space-between"
          alignItems="flex-start"
          gap={{ base: 10, md: 4 }}
        >
          {/* right side */}

          {/* left side */}
          {videoDetails?.url == "no" ? (
            <Heading>Comming Soon</Heading>
          ) : (
            videoDetails && (
              <VStack
                alignItems="center"
                justifyContent="center"
                w="100%"
                h="100%"
                spacing="40px"
                m="0 !important"
                mt="10px !important"
              >
                <Box w={{ base: "100%", md: "50%" }}>
                  <VideoPreview
                    loading={loading}
                    otp={otp}
                    playBack={playBack}
                  />
                </Box>

                {/* video materials  */}
                <VStack
                  w={{ base: "100%", md: "80%" }}
                  alignItems="flex-start"
                  color="main_1"
                >
                  {videoDetails?.files?.length != 0 && (
                    <Text fontSize="26px" fontWeight="500">
                      Video materials
                    </Text>
                  )}
                  <Flex w="100%" flexWrap="wrap" gap="4">
                    {videoDetails?.files?.map((val, idx) => {
                      return (
                        <HStack
                          key={idx}
                          w="23.5%"
                          h="70px"
                          bg="main_1_light"
                          justify="space-between"
                          borderRadius="8px"
                          p="10px"
                          position="relative"
                        >
                          <Text>File title</Text>

                          <Square
                            size="40px"
                            bg="main_1"
                            color="white"
                            borderRadius="8px"
                          >
                            <Icon as={RiDownload2Line} />
                          </Square>
                          <a
                            href={`${baseUrl}/${val?.file}`}
                            download
                            style={{
                              width: "100%",
                              height: "100%",
                              position: "absolute",
                            }}
                            target="_blank"
                            rel="noreferrer"
                          ></a>
                        </HStack>
                      );
                    })}
                  </Flex>
                </VStack>

                {/* video description */}

                {videoDetails?.homework?.name && (
                  <VStack
                    w={{ base: "100%", md: "80%" }}
                    alignItems="flex-start"
                    color="main_1"
                  >
                    <Text fontSize="26px" fontWeight="500">
                      Video Related Homework{" "}
                    </Text>
                    <Box
                      onClick={() => dispatch(openSolveHomeworkModel())}
                      style={{
                        paddingLeft: "20px",
                        cursor: "pointer",
                        textDecoration: "underline",
                        fontWeight: "500",
                      }}
                    >
                      {videoDetails?.homework?.name}
                    </Box>
                  </VStack>
                )}

                {videoDetails?.exams?.length > 0 && (
                  <VStack
                    w={{ base: "100%", md: "80%" }}
                    alignItems="flex-start"
                    color="main_1"
                  >
                    <Text fontSize="26px" fontWeight="500">
                      Video Related Exams{" "}
                    </Text>
                    {videoDetails?.exams?.map((val) => {
                      return (
                        <Box
                          style={{
                            paddingLeft: "20px",
                            cursor: "pointer",
                            textDecoration: "underline",
                            fontWeight: "500",
                          }}
                          onClick={() =>
                            navigate(
                              `/exam-guide/${val?.id}?name=${videoDetails?.chapter?.name}`
                            )
                          }
                        >
                          {val?.name}
                        </Box>
                      );
                    })}
                  </VStack>
                )}

                {videoDetails?.quiz_hw?.length > 0 && (
                  <VStack
                    w={{ base: "100%", md: "80%" }}
                    alignItems="flex-start"
                    color="main_1"
                  >
                    <Text fontSize="26px" fontWeight="500">
                      Video Related Exams{" "}
                    </Text>
                    {videoDetails?.quiz_hw?.map((val) => {
                      return (
                        <Box
                          style={{
                            paddingLeft: "20px",
                            cursor: "pointer",
                            textDecoration: "underline",
                            fontWeight: "500",
                          }}
                          onClick={() =>
                            navigate(
                              `/solve-exam/${val?.id}?name=${videoDetails?.chapter?.name}`
                            )
                          }
                        >
                          {val?.name}
                        </Box>
                      );
                    })}
                  </VStack>
                )}
              </VStack>
            )
          )}
        </Stack>
      </Container>
    </Layout>
  );
};

export default VideosPreview;
